module.exports = __webpack_public_path__ + "img/26_24.93efad76.png";